import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { Tooltip as ExternalTooltip, PositionStrategy } from 'react-tooltip';
import { Info } from 'src/assets/dynamicSvg';

const Div = styled.div`
  svg {
    outline: none;
  }

  .react-tooltip {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: ${({ theme }) => theme.colors.white} !important;
    background-color: ${({ theme }) => theme.colors.prussianBlue} !important;
  }

  .tooltip-children-inline {
    display: inline-flex;
    align-items: center;
    width: fit-content;
  }
`;

interface TooltipProps {
  dataId?: string;
  dataHtml: string;
  children?: React.ReactNode;
  place?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: number;
  positionStrategy?: PositionStrategy;
  noIcon?: boolean;
  delayShow?: number;
  infoIconStyle?: React.CSSProperties;
  inline?: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({
  dataId = 't-tip',
  dataHtml,
  children,
  place = 'left',
  maxWidth = 440,
  positionStrategy = 'absolute',
  noIcon = false,
  delayShow,
  infoIconStyle,
  inline = false,
}) => {
  return (
    <Div>
      {createPortal(
        <Div>
          <ExternalTooltip
            id={dataId}
            place={place}
            positionStrategy={positionStrategy}
            style={{
              zIndex: 9999,
              maxWidth,
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              borderRadius: '6px',
              whiteSpace: 'pre-wrap',
            }}
            delayShow={delayShow}
            css={`
              * {
                word-break: break-word;
                overflow-wrap: break-word;
                word-wrap: break-word;
              }
            `}
            opacity={1}
          />
        </Div>,
        document.body,
      )}
      {children ? (
        <div
          data-tooltip-id={dataId}
          data-tooltip-html={dataHtml}
          className={inline ? 'tooltip-children tooltip-children-inline' : 'tooltip-children'}
        >
          {children}
        </div>
      ) : (
        <>{noIcon ? null : <Info data-tooltip-id={dataId} data-tooltip-html={dataHtml} style={infoIconStyle} />}</>
      )}
    </Div>
  );
};
